import { lazy } from 'react';
export const lockedFeatureUpgradeRegistry = {
  namespace: 'LOCKED_FEATURE_UPGRADE',
  components: {
    LOCKED_FEATURE_UPGRADE_CARD: /*#__PURE__*/lazy(() => import('./LockedFeatureUpgradeCard').then(m => ({
      default: m.LockedFeatureUpgradeCard
    })))
  }
};